module.exports = __webpack_public_path__ + "img/bg_function01_2_m.6435ced1.gif";